import React from 'react';
import {
  addPathToList,
  Customer_select_source,
  File_type_recommended,
  getSubCategoryId, Icon_dynamically,
  Select_loan_source,
} from '../utils/DictionaryManagementUtils';
import FullPagePanel from '../components/PanelsComponents/General/FullPagePanel';
import AssetRequirements from '../components/PanelsComponents/General/AssetRequirements';

//= ========================================================================
const Panel_J03_LoanSelectSource = ({
  globJSON,
  selectedScreen,
  onConfigChanged,
  onStepPressed,
  onGotoEdit,
  language,
}) => {
  const editTextList = [
    'select_loan_source',
  ];
  const myScreen = globJSON.screens[selectedScreen];
  const subCategoryId = getSubCategoryId(myScreen);
  const service = globJSON.configurations.services[subCategoryId];

  return (
    <FullPagePanel
      globJSON={globJSON}
      onConfigChanged={onConfigChanged}
      selectedScreen={selectedScreen}
      onStepPressed={onStepPressed}
      onGotoEdit={onGotoEdit}
      panelHeadline={Select_loan_source}
      editTextList={addPathToList(editTextList, `configurations/services/${subCategoryId}/source/`)}
      tooltipsTitles={service.screens_ordering}
      paragraph={Customer_select_source}
      language={language}
    >
      <AssetRequirements paragraph={Icon_dynamically} details={File_type_recommended} />
    </FullPagePanel>
  );
};

export default Panel_J03_LoanSelectSource;
